import { Field, Form, Formik } from 'formik';
import { InputType } from '../../../../Common/FormFields/InputType';
import { Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import RoundButton from '../../../../Common/RoundButton';
import ErrorMessage from '../../../../Common/ErrorMessage';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
// import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Checkbox from '@mui/material/Checkbox';
import ReferralModal from './ReferralModal';
import Button from '@mui/material/Button';
import stashearnLogo from '../../../../utils/assests/stashearn-logo.png';
import backArrow from '../../../../utils/assests/back-arrow.svg';
import LogoNew from '../../../../utils/assests/logo-bottom.png';
import splashImgOne from '../../../../utils/assests/splash-image-01.png';
import splashImgTwo from '../../../../utils/assests/splash-image-02.png';
import splashImgThree from '../../../../utils/assests/splash-image-03.png';
import splashImgFour from '../../../../utils/assests/splash-image-04.png';
import returnImg from '../../../../utils/assests/returns.png';
import loginIcon from '../../../../utils/assests/login-icon.png';
import Grid from '@mui/material/Grid';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function LoginForm({
  initialValues,
  validationSchema,
  onSubmitHandle,
  error,
  isLoading,
  onPhoneChange,
  referralCode,
  onChangeReferral,
  onClickReferalModal,
  referalModal,
  onClickNext,
  checkFocus,
  isFocus,
  checkBoxValue,
  handleChangeCheckbox,
  userError,
  setUserError,
  enterKeyPress,
  formikRef,
}: any) {
  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <Box
        className='lightGrayBackgroud column-fluid withBorder'
        sx={{ display: 'none' }}
      >
        <Box className=' splashScreen'>
          <img src={LogoNew} alt='Logo' />
          <Typography variant='h1'>
            A new-age <br /> peer to peer investment platform <br /> in
            collaboration with RBI <br /> registered NBFC-P2P, LiquiLoans
          </Typography>
        </Box>
      </Box>

      <Slider {...settings} className='withBorder appInfo'>
        <Box>
          <Box className='splash column-fluid'>
            <Grid
              container
              direction='column'
              justifyContent='center'
              alignItems='center'
            >
              <Grid item>
                <img src={splashImgOne} alt='' className='mainImg' />
              </Grid>
              <Grid item>
                <Typography variant='h1'>Multiply your wealth,</Typography>
                <Typography>watch it grow</Typography>
              </Grid>
              <Grid>
                <img src={returnImg} alt='' />
              </Grid>
            </Grid>
            <Box className='splashBottomLogo'>
              <img src={LogoNew} alt='' />
            </Box>
          </Box>
        </Box>
        <Box>
          <Box className='splash column-fluid'>
            <Grid
              container
              direction='column'
              justifyContent='center'
              alignItems='center'
            >
              <Grid item>
                <img src={splashImgTwo} alt='' className='mainImg' />
              </Grid>
              <Grid item>
                <Typography variant='h1'>We don’t hide!</Typography>
                <Typography variant='h2'>
                  Say goodbye to hidden <br />
                  chargets and say hello <br /> to transparent investment.
                </Typography>
              </Grid>
            </Grid>
            <Box className='splashBottomLogo'>
              <img src={LogoNew} alt='' />
            </Box>
          </Box>
        </Box>
        <Box>
          <Box className='splash column-fluid'>
            <Grid
              container
              direction='column'
              justifyContent='center'
              alignItems='center'
            >
              <Grid item>
                <img src={splashImgThree} alt='' className='mainImg' />
              </Grid>
              <Grid item>
                <Typography variant='h1'>It’s a safe choice</Typography>
                <Typography variant='h2'>
                  Your portfolio will be <br /> diversified among a pool <br />
                  of credit worthy borrowers
                </Typography>
              </Grid>
            </Grid>
            <Box className='splashBottomLogo'>
              <img src={LogoNew} alt='' />
            </Box>
          </Box>
        </Box>
        <Box>
          <Box className='splash column-fluid'>
            <Grid
              container
              direction='column'
              justifyContent='center'
              alignItems='center'
            >
              <Grid item>
                <img src={splashImgFour} alt='' className='mainImg' />
              </Grid>
              <Grid item>
                <Typography variant='h1'>It’s your precise move</Typography>
                <Typography variant='h2'>
                  To build a better & more <br /> responsible financial future.
                </Typography>
              </Grid>
            </Grid>
            <Box className='splashBottomLogo'>
              <img src={LogoNew} alt='' />
            </Box>
          </Box>
        </Box>
      </Slider>
      {/* <Box className={isFocus ? 'shortHeader' : 'loginHeader'}>
        <Box
          sx={{
            mb: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <img style={{ display: 'none' }} src={backArrow} alt='' />
          <img className='stashearnLogo' src={stashearnLogo} alt='' />
        </Box>
        {isFocus ? (
          <Box>
            <Typography variant='h6'>enter your mobile no</Typography>
            <Typography>we will send you an OTP to verify your no</Typography>
          </Box>
        ) : (
          <Typography variant='h1'>
            let's get <br /> started…
          </Typography>
        )}
      </Box> */}

      <Box
        className='contentArea column-fluid loginScreen text-center mt-0 radius-0 no-shadow'
        sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
      >
        <Box className='headingBox'>
          <Typography variant='h1' className='fw-800 text-blue text-center'>
            Enter your number &amp; begin <br /> earning high returns
          </Typography>
          <img className='loginIcon' src={loginIcon} alt='' />
        </Box>

        <Formik
          validateOnMount={true}
          innerRef={formikRef}
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(value) => onSubmitHandle(value)}
        >
          {({ handleSubmit, values, touched, errors }) => (
            <Form>
              <div>
                <Field
                  component={InputType}
                  placeholder='Please enter mobile number'
                  name='phone'
                  maxLength={10}
                  value={values.phone}
                  onChange={onPhoneChange}
                  onKeyPress={enterKeyPress}
                />
              </div>
              <div className='termsAndConditions'>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkBoxValue}
                        onChange={handleChangeCheckbox}
                        color='default'
                      />
                    }
                    label={
                      <p>
                        I agree to Stashfin{' '}
                        <a
                          href='https://dev.stashfin.com/Terms_For_Business_Introduction'
                          target='_blank'
                        >
                          terms {'&'} conditions {'&'} privacy policy
                        </a>
                      </p>
                    }
                  />
                </FormGroup>
              </div>
              {values.phone.length >= 10 && !checkBoxValue && (
                <ErrorMessage text={'Please check terms & conditions'} />
              )}
              <Box className='referalBox'>
                <Button type='button' onClick={() => onClickReferalModal()}>
                  Having a referral code
                </Button>
              </Box>
              {values.phone.length < 10 && setUserError(false)}
              <div>
                {userError && <ErrorMessage text={'User not registered.'} />}
              </div>
              <div>
                <RoundButton
                  title='continue'
                  type='submit'
                  disable={isLoading}
                />
              </div>
            </Form>
          )}
        </Formik>
        <ReferralModal
          referralCode={referralCode}
          onChangeReferral={onChangeReferral}
          open={referalModal}
          onClose={onClickReferalModal}
          onClickNext={onClickNext}
        />
        {error && <ErrorMessage text='Some error' />}

        <Box className='splashBottomLogo'>
          <img src={LogoNew} alt='' />
        </Box>
      </Box>
    </>
  );
}
